import mixitup from 'mixitup';
import mixitupPagination from 'mixitup-pagination';
mixitup.use(mixitupPagination);
export default class FrontPagination{

    constructor(element) {
        this._wrapper = element;
        this._mix = this._wrapper.querySelector('.js-front-pagination-mix');


        this.init();
        this.bindEvents();
    }
    
    bindEvents(){
        window.addEventListener('resize', app.debounce(() => {
            this.mix.paginate({
                limit: this.getLimit()
            });
        }));
    }

    init(){
        this.mix = mixitup(this._mix, {
            controls: {
                scope: 'local'
            },
            pagination : { 
                limit: this.getLimit(),
                hidePageListIfSinglePage:true
            },
        });
    }
    
    getLimit(){
        if(window.matchMedia('(max-width:576px').matches){
            return 1;
        }
        if(window.matchMedia('(max-width:1200px').matches){
            return 2;
        }
        if(window.matchMedia('(max-width:1400px').matches){
            return 3;
        }
        return 4;
    }

}